<template>
  <transition name="window" :enter-active-class="getTransitionClass" appear>
    <slot />
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';


const { alignmentOrigin } = defineProps<{
  alignmentOrigin: string
}>();

const getTransitionClass = computed(
  () => `window-enter-${alignmentOrigin}-active`,
);

</script>

<style lang="scss">
.window-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.window-enter-active {
  transition: opacity 0.25s, transform 0.3s cubic-bezier(0.1, 0.8, 0.3, 2);
  transform-origin: bottom right;
  z-index: 10000;
}

.window-enter-right-active {
  transition: opacity 0.25s, transform 0.3s cubic-bezier(0.1, 0.8, 0.3, 2);
  transform-origin: bottom right;
  z-index: 10000;
}

.window-enter-left-active {
  transition: opacity 0.25s, transform 0.3s cubic-bezier(0.1, 0.8, 0.3, 2);
  transform-origin: bottom left;
  z-index: 10000;
}


.window-enter-to {
  opacity: 1;
  transform: scale(1);
}


.window-leave-from {
  opacity: 1;
  transform: scale(1);
}

.window-leave-active {
  transition: opacity 0.25s, transform 0.25s ease-in-out;
  transform-origin: calc(100% - 30px) calc(100% - 30px);
}

.window-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
